"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = require("react");

function default_1(ref) {
  const initialState = {
    overflowX: false,
    overflowY: false
  };
  const [overflow, setOverflow] = (0, react_1.useState)(initialState);
  (0, react_1.useEffect)(() => {
    if (!ref.current || !('ResizeObserver' in window)) {
      return;
    }

    const handleResize = () => {
      if (!ref.current) {
        return;
      }

      if (overflow.overflowX === ref.current.scrollWidth > ref.current.clientWidth && overflow.overflowY === ref.current.scrollHeight > ref.current.clientHeight) {
        return;
      }

      setOverflow({
        overflowX: ref.current.scrollWidth > ref.current.clientWidth,
        overflowY: ref.current.scrollHeight > ref.current.clientHeight
      });
    };

    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(ref.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [ref, overflow]);
  return overflow;
}

exports.default = default_1;